import { RefreshCw } from "lucide-react";
import { CharCounter } from "@agent/components/PostPreview";
import { VisualPanel } from "@agent/components/VisualPanel";
import { BlogVersionSection } from "@agent/components/BlogVersionSection";
import { PublishActionsBar } from "@agent/components/PublishActionsBar";
import { inputCls, labelCls, STATUS_COLORS } from "@agent/lib/styles";

export function DraftEditorPanel({
  draft, setDraft, onNewDraft, overLimit,
  instruction, setInstruction, regenLoading, regenerate,
  blogGenerated, blogGenLoading, generateBlog, showBlog, setShowBlog,
  saving, canPublish, linkedinReady, liConnected, liHasOrgId, onCopyLinkedin, onSave, onApprove, onOpenPublish,
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-[0_4px_30px_rgba(15,23,42,0.05)] p-6 space-y-5 fade-up">
      <div className="flex items-center justify-between">
        <span data-testid="draft-status-badge" className={`text-[11px] tracking-[0.15em] font-semibold px-3 py-1 rounded-full border uppercase ${STATUS_COLORS[draft.status]}`}>{draft.status}</span>
        <button data-testid="new-draft-btn" onClick={onNewDraft} className="text-xs font-medium text-slate-500 hover:text-indigo-600 transition-colors duration-150">+ New draft</button>
      </div>
      <div>
        <label className={labelCls}>Title (internal)</label>
        <input data-testid="draft-title-input" className={inputCls} value={draft.title} onChange={(e) => setDraft({ ...draft, title: e.target.value })} />
      </div>
      <div>
        <div className="flex items-center justify-between mb-1.5">
          <label className="text-[11px] tracking-[0.2em] uppercase text-slate-400 font-semibold">Content</label>
          <CharCounter content={draft.content} />
        </div>
        <textarea data-testid="draft-content-input" rows={14} value={draft.content}
          onChange={(e) => setDraft({ ...draft, content: e.target.value })}
          className={`${inputCls} resize-y leading-relaxed ${overLimit ? "border-rose-400 ring-1 ring-rose-300" : ""}`} />
      </div>
      <div className="flex gap-2">
        <input data-testid="regenerate-instruction-input" className={inputCls} value={instruction} onChange={(e) => setInstruction(e.target.value)}
          placeholder="Regenerate instruction, e.g. 'shorter, add a hook'…" />
        <button data-testid="regenerate-btn" onClick={regenerate} disabled={regenLoading}
          className="flex items-center gap-2 px-5 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500 text-white text-xs font-semibold hover:opacity-90 transition-opacity duration-150 disabled:opacity-40 whitespace-nowrap">
          <RefreshCw size={13} className={regenLoading ? "animate-spin" : ""} /> {regenLoading ? "…" : "Regen"}
        </button>
      </div>
      <VisualPanel draft={draft} onDraftUpdate={setDraft} />
      <BlogVersionSection draft={draft} setDraft={setDraft} blogGenerated={blogGenerated}
        blogGenLoading={blogGenLoading} generateBlog={generateBlog} showBlog={showBlog} setShowBlog={setShowBlog} />
      <PublishActionsBar draft={draft} saving={saving} overLimit={overLimit} canPublish={canPublish}
        linkedinReady={linkedinReady} liConnected={liConnected} liHasOrgId={liHasOrgId}
        onCopyLinkedin={onCopyLinkedin} onSave={onSave} onApprove={onApprove} onOpenPublish={onOpenPublish} />
    </div>
  );
}
